import {EntityData, field} from "@fedeltapointofsale/data-client";

export class CreditInvoiceData extends EntityData<CreditInvoiceData> {
    @field invoiceId: number;

}
